"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBalance = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconBalance = function IconBalance(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.871 17.447a.455.455 0 00-.328-.137H19.14a.34.34 0 01-.34-.34V9.455A.455.455 0 0018.347 9h-4.678a.455.455 0 00-.455.455v7.515a.34.34 0 01-.34.34h-2.41a.455.455 0 00-.325.78l5.543 5.774A.455.455 0 0016 24c.122 0 .24-.048.326-.136l5.536-5.773a.455.455 0 00.009-.644zM2.129 6.553a.455.455 0 00.328.137H4.86a.34.34 0 01.34.34v7.515c0 .251.203.455.454.455h4.678a.455.455 0 00.455-.455V7.03a.34.34 0 01.34-.34h2.41a.455.455 0 00.325-.78L8.32.135A.455.455 0 007.999 0a.455.455 0 00-.325.136L2.137 5.909a.455.455 0 00-.008.644z"
  }));
};
exports.IconBalance = IconBalance;